// extracted by mini-css-extract-plugin
export default {"control":"Product_control__USnjB","richText":"Product_richText__hzrSa"};